<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-4 col-xlg-3 col-md-5">
        <div class="card">
          <div class="card-body text-center">
            <div class="profile-pic m-b-20 m-t-20">
              <blockie v-if="user.email" :address="user.email" style="width: 150px" />
              <h4 class="m-t-20 m-b-0">
                {{ user.first_name }}&nbsp;{{ user.last_name }}
              </h4>
              <h5 class="m-b-0">
                {{ user.org.name }}
              </h5>
              <a href="mailto:danielkristeen@gmail.com">{{ user.email }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3 col-xs-6 b-r">
                <strong>Full Name</strong>
                <br>
                <p class="text-muted">
                  {{ user.first_name }}&nbsp;{{ user.last_name }}
                </p>
              </div>
              <div class="col-md-3 col-xs-6 b-r">
                <strong>Mobile</strong>
                <br>
                <p class="text-muted">
                  {{ user.org.phone }}
                </p>
              </div>
              <div class="col-md-3 col-xs-6 b-r">
                <strong>Email</strong>
                <br>
                <p class="text-muted">
                  {{ user.email }}
                </p>
              </div>
              <div class="col-md-3 col-xs-6">
                <strong>Location</strong>
                <br>
                <p class="text-muted">
                  {{ user.org.address.line1 }}&nbsp;{{ user.org.address.line2 }}&nbsp;{{ user.org.address.city }}&nbsp;{{ user.org.address.city }}&nbsp;{{ user.org.address.state }}&nbsp;{{ user.org.address.country }}&nbsp;{{ user.org.address.zip_code }}
                </p>
              </div>
            </div>
            <template v-if="user_props">
              <hr>
              <p class="m-t-30">
                {{ user_props.objective }}
              </p>
              <h4 class="font-medium m-t-30">
                Skill Set
              </h4>
              <hr>
              <p class="m-t-30">
                {{ user_props.skills }}
              </p>

              <h4 class="font-medium m-t-30">
                Work Experience
              </h4>
              <hr>
              <div v-for="(we, index) in user_props.work_experience" class="timeline-panel mb-4">
                <div class="timeline-heading">
                  <h4 class="timeline-title">
                    {{ we.corporation }}
                  </h4>
                </div>
                <div v-for="(e, index) in we.experiences" class="timeline-body">
                  <p>&nbsp;&nbsp;{{ index+1+'.' }}&nbsp;{{ e }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Blockie from '../../common/Blockie.vue';

export default {
  name: 'UserProfile',
  components: { Blockie },
  props: ['userId'],
  data() {
    return {
      user: {
        user: null,
        email: null,
        first_name: null,
        last_name: null,
        email2f_enabled: null,
        totp_enabled: null,
        hotp_enabled: null,
        u2f_enabled: null,
        image: null,
        email_verified: null,
        status: null,
        org: {
          name: null,
          email: null,
          web: null,
          phone: null,
          description: null,
          image: null,
          address: {
            address: null,
            line1: null,
            line2: null,
            city: null,
            state: null,
            zip: null,
            country: null
          }
        }
      },
      user_props: {
        objective: 'I believe that I would be a great fit because I am passionate and experienced. I have 16 years of\nexperience in the casino business as an auditor and 12 years of experience in the banking\nbusiness as a bank teller and auditor and believe my strong work ethic would be a major asset to\nyour already successful business. I look forward to hearing back from you and hopefully becoming\na part of the Family.',
        skills: 'Excel, Word, GSA, Jet Scan, Jet Sort, Power Point, IGS System, CDI, CDS, Aristocrat System,\nUnisource, Quickbooks, JD Edwards, AS400, ACSC, Bally Technology',
        work_experience: [
          {
            corporation: 'ABC Corporation,  October 2005 – March 2006',
            experiences: [
              'Audited independent departments to ensure that they are incompliance with the MICS',
              'Reviewed SOPs for all department to ensure that they are in compliance',
              'Reviewed the financial reporting of each audit to ensure accuracy and to ensure compliance\nwith the policies and procedures set by the NIGC',
              'Prepared revenue reports that facilitated the general ledger posting process for month-end',
              'Compiled the reports from the revenue centers and prepared daily revenue flash reports',
              'Assisted Compliance Agent in matters that required experienced trouble-shooting skills and\nproblem-solving skills',
              'Observed the Slot technician when doing moves or conversion and upgrades to ensure that\nEprom, Par %, Hold are correct'
            ]
          },
          {
            corporation: 'DEF Corporation,  2001 - 2005',
            experiences: [
              'Performed audits on all departments of the bank',
              'Evaluated policy and procedures on every audit, including quality of work performed.',
              'Evaluated employees of each department',
              'Created audit programs, performance spreadsheets, audit reports and proposed changes for\nerrors noted',
              'Reported final audits to department manager for approval.',
              'Changes were implemented to ensure the bank was in compliance with bank policy and\nprocedures as well as outside auditors',
              'Skills Used Integrity, critical thinking, communication, leadership'
            ]
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getUser();
    },
    async getUser() {
      try {
        const { data } = await this.$accounts.get(`accounts/orgs/${this.orgid}/users/${this.memberid}`);
        this.user = data;
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>

<style scoped>
</style>
